import React from 'react';
import {useStyles} from "../ArticleSalePrices.style";
import clsx from "clsx";
import ArticleSalePriceRowProperties from './ArticleSalePriceRowProperties';
import ShowText from '../../../../../shared_components/Info/ShowText/ShowText';
import ShowImage from '../../../../../shared_components/Info/ShowImage/ShowImage';
import ShowPrice from '../../../../../shared_components/Info/ShowPrice/ShowPrice';
import Currency from '../../../../../entities/Currency';
import ShowDeliveryTime from '../../../../../shared_components/Info/ShowDeliveryTime/ShowDeliveryTime';
import ButtonSize from '../../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../../ui_components/Button/ButtonType';
import NewArticleSalePriceButton from '../../../../../shared_components/Buttons/NewArticleSalePriceButton/NewArticleSalePriceButton';
import ExpandoMenu from '../../../../../ui_components/ExpandoMenu/ExpandoMenu';
import RemoveArticleSalePriceButton from '../../../../../shared_components/Buttons/RemoveArticleSalePriceButton/RemoveArticleSalePriceButton';

const ArticleSalePriceRowMedium: React.FC<ArticleSalePriceRowProperties> = ({
                                                            article,
                                                            salePrice,
                                                            onUpdate = () => {
                                                            },
                                                        }) => {

    const classes = useStyles();

    const articleSalePrices = salePrice?.articleSalePrices.filter(t => t.articleId === article.id);

    return (
        <div
            className={clsx()}>
                <div className={classes.article_container} key={article.id}>
                    <div className={classes.article_header}>
                        <div className={classes.article_name}>
                            <ShowImage imageName={article.defaultImage} width={60} height={60}/>
                            <ShowText text={article.name} className={classes.article_name_container}/>
                        </div>
                        <div>
                            <NewArticleSalePriceButton
                                size={ButtonSize.SMALL}
                                onSave={onUpdate}
                                salePriceId={salePrice?.id ?? ''}
                                articleId={article.id}
                                articleName={article.name}
                                value={0}
                                deliveryTimeDays={undefined}
                                type={ButtonType.SECONDARY}
                            />
                        </div>
                    </div>
                    <div className={classes.sale_prices_values_container}>
                        {articleSalePrices?.map((articlePrice, i) => (
                            <div key={i} className={classes.currencies_values_container}>
                                <div className={classes.price_and_button_container}>
                                    <ShowPrice value={articlePrice.salePrice} currency={Currency.DOLLAR}/>
                                    <ExpandoMenu className={classes.expando_sale_price_button} openToRight={true} size={ButtonSize.SMALL}>
                                        <NewArticleSalePriceButton
                                            size={ButtonSize.SMALL}
                                            onSave={onUpdate}
                                            salePriceId={salePrice?.id ?? ''}
                                            articleSalePriceId={articlePrice.id}
                                            articleId={article.id}
                                            articleName={article.name}
                                            value={articlePrice.salePrice}
                                            deliveryTimeDays={articlePrice.deliveryTimeDays}
                                            type={ButtonType.SECONDARY}
                                        />
                                        <RemoveArticleSalePriceButton
                                                size={ButtonSize.SMALL} onSave={onUpdate}
                                                salePriceId={salePrice?.id ?? ''}
                                                articleSalePriceId={articlePrice.id}
                                                showText
                                                type={ButtonType.SECONDARY}
                                        />
                                    </ExpandoMenu>

                                </div>
                                
                                <ShowDeliveryTime deliveryTime={articlePrice.deliveryTimeDays}/>
                            </div>
                        ))}
                    </div>
                </div>
        </div>
    )
}

export default ArticleSalePriceRowMedium;
